import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";
import moment from "moment";
import { Prompt } from "react-router";

import { documentActions } from "actions";
import { connect } from "react-redux";

import { DOCUMENT_TYPE_PHOTO } from "constants/dbValues";
import { Can } from "constants/abilityContext";
import {
  history,
  title,
  isChecked,
  validateProfileFields,
  dateFormat,
  selectProps,
  displayErrorContext,
  renderProjectSelectOption,
} from "utils";

import { Header } from "components";
import { Icon, Input, notification, Select, Radio, Button, Divider, Spin } from "antd";

import {
  documentService,
  projectService,
  userService,
  tailgateService,
  selectService,
} from "services";

class DocumentCreatePage extends Component {
  constructor(props) {
    super(props);

    const { id, model, target, type } = this.props.match.params;
    const { full } = this.props;

    this.state = {
      document: {
        __type: "Document",
        id: id,
        type_id: full ? null : DOCUMENT_TYPE_PHOTO,
        document_type: full ? {} : { accept: "image/*" },

        model,
        target_id: target,
      },
      errors: {},
      edited: false,
      types: [],
      projects: [],
      users: [],
      tailgates: [],

      uploading: false,
    };
  }

  async componentDidMount() {
    const { full } = this.props;
    const { model, target, type } = this.props.match.params;
    const UNSPECIFIED_UPLOAD = !model || !target || !type;
    if (UNSPECIFIED_UPLOAD) {
      const projects = await projectService.list({
        order_by: "code,label",
        order_direction: "ASC,ASC",
        disabled: 0,
      });
      const users = await userService.list();
      const tailgates = await tailgateService.list();

      this.setState({ projects, users, tailgates });
    }
    if (full) {
      const selects = await selectService.listForPage("document");
      this.setState({ types: selects.DocumentType });
    } else {
      this.btn.click();
    }
  }

  handleChange(value, key) {
    if (key === "model")
      this.setState({
        document: { ...this.state.document, [key]: value, target_id: null },
        edited: true,
      });
    else if (key === "type_id")
      this.setState({
        document: {
          ...this.state.document,
          [key]: value,
          document_type: this.state.types.find((t) => t.id === value),
        },
        edited: true,
      });
    else this.setState({ document: { ...this.state.document, [key]: value }, edited: true });
  }

  handleSubmit() {
    const { full } = this.props;
    if (!this.validateFields()) return;

    const modelToFr = (model) => {
      if (model.toLowerCase() === "project") return "projet";
      if (model.toLowerCase() === "user") return "utilisateur";
      if (model.toLowerCase() === "tailgate") return "tailgate";
      return model;
    };

    var document = { ...this.state.document };
    document.label = `(${moment().format(dateFormat)})`;
    // document.label = `Photo d'un ${ modelToFr(document.model) } (${ moment().format(dateFormat) })`;

    this.setState({ uploading: true });
    documentService
      .create(document)
      .then((n) => {
        notification.open({
          message: "Document(s) téléversé(s)",
          description: "Vos documents ont été enregistrés avec succès.",
          placement: "bottomRight",
        });

        this.setState({ edited: false, uploading: false });
        if (full) history.replace(`/documents`);
        else history.goBack();
      })
      .catch((e) => {
        this.setState({ uploading: false });
        notification.open({
          message: "Une erreur s'est produite",
          description: "Veuillez réessayer ou contacter un administrateur.",
          placement: "bottomRight",
        });
      });
  }

  validateFields() {
    const { document } = this.state;

    var fields = ["type_id", "urls", "model", "target_id"];
    var validation = validateProfileFields(document, fields);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  render() {
    const { full, single } = this.props;
    const { errors, types, uploading } = this.state;
    const { urls, model, target_id, type_id, document_type } = this.state.document;
    var list = [];

    let UNSPECIFIED_UPLOAD = true;
    {
      const { model, target, type } = this.props.match.params;
      UNSPECIFIED_UPLOAD = !model || !target || !type;
    }

    if (UNSPECIFIED_UPLOAD && model) {
      switch (model.toLowerCase()) {
        case "project":
          list = (this.state.projects || []).map((p) => ({
            id: p.id,
            label: renderProjectSelectOption(p),
          }));
          break;
        case "user":
          list = (this.state.users || []).map((u) => ({
            id: u.id,
            label: u.name + " " + u.surname,
          }));
          break;
        case "tailgate":
          list = (this.state.tailgates || []).map((t) => ({
            id: t.id,
            label: t.project.label + " / " + moment(t.date).format(dateFormat),
          }));
          break;
      }
    }

    var mode = "mobile-create",
      pageTitle = "Photo",
      header = "Nouvelle photo",
      bread = [];

    if (full) {
      mode = "create";
      pageTitle = "Création d'un média";
      header = "Nouveau média";
      bread = [{ to: "/documents", text: "Liste des médias" }, { text: "Création" }];
    }

    const inputProps = !single && { multiple: true };

    return (
      <Fragment>
        <Helmet>{title(pageTitle)}</Helmet>

        <Header title={header} bread={bread} />

        <Spin
          indicator={<Icon type="loading" spin style={{ color: "white", fontSize: "52px" }} />}
          spinning={uploading}
        >
          <div className={`document-page main-content profile-content ${mode}`}>
            <Can do={"read"} on={"Document"}>
              <Fragment>
                {full && (
                  <div className="ctn">
                    <label>Type :</label>
                    <span className={errors && errors.type_id ? "error-wrap" : ""}>
                      <Select
                        {...selectProps()}
                        onChange={(value) => this.handleChange(value, "type_id")}
                        value={type_id}
                      >
                        {types.map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </span>
                  </div>
                )}

                <div className="ctn">
                  <span className={errors && errors.urls ? "error-wrap" : ""}>
                    <input
                      {...inputProps}
                      ref={(input) => (this.btn = input)}
                      type="file"
                      accept={full ? document_type.accept || "*" : "image/*"}
                      onChange={(e) => this.handleChange(e.target.files, "urls")}
                      disabled={!type_id}
                    />
                  </span>
                </div>

                {UNSPECIFIED_UPLOAD && (
                  <div className="ctn">
                    <span className={errors && errors.model ? "error-wrap" : ""}>
                      <Radio.Group
                        onChange={(e) => this.handleChange(e.target.value, "model")}
                        value={model}
                      >
                        <Radio value="Project">Projet</Radio>
                        <Radio value="User">Utilisateur</Radio>
                        {/* <Radio value="Tailgate">Tailgate</Radio> */}
                      </Radio.Group>
                    </span>
                  </div>
                )}

                {list.length > 0 && (
                  <Fragment>
                    <div className="ctn">
                      <span className={errors && errors.target_id ? "error-wrap" : ""}>
                        <Select
                          {...selectProps()}
                          onChange={(value) => this.handleChange(value, "target_id")}
                          value={target_id ? parseInt(target_id) : null}
                        >
                          {list.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </span>
                    </div>
                  </Fragment>
                )}

                {displayErrorContext(errors)}

                <div className="buttons">
                  <Button type="link" onClick={() => history.goBack()}>
                    Annuler
                  </Button>
                  <Button
                    type="primary"
                    disabled={!full && (!urls || !model || !target_id)}
                    onClick={() => this.handleSubmit()}
                  >
                    {full ? "Créer le média" : "Finir la prise de photo"}
                  </Button>
                </div>

                <Prompt
                  when={this.state.edited}
                  message="Attention, certaines de vos modifications n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?"
                />
              </Fragment>
            </Can>
          </div>
        </Spin>
      </Fragment>
    );
  }
}

export default DocumentCreatePage;
